var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94265233,-4.97379915e-14 C15.4338276,-4.97379915e-14 19.8853047,4.45147708 19.8853047,9.94265233 C19.8853047,15.4338276 15.4338276,19.8853047 9.94265233,19.8853047 C4.45147708,19.8853047 1.31450406e-12,15.4338276 1.31450406e-12,9.94265233 C1.31450406e-12,4.45147708 4.45147708,-4.97379915e-14 9.94265233,-4.97379915e-14 Z M10.4426523,1.94265233 L9.44265233,1.94265233 L9.44265233,10.1497591 L14.7890989,15.4962057 L15.4962057,14.7890989 L10.442,9.735 L10.4426523,1.94265233 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.383400f401c109f40a9b0959252ec71b.svg";
export { ForwardRef as ReactComponent };